import "./App.css";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import { useState, useEffect } from "react";
function App() {
  useEffect(() => {
    if (localStorage.getItem("darkMode")) {
      const stored = JSON.parse(localStorage.getItem("darkMode"));
      setDarkMode(stored);
    } else {
      setDarkMode(false);
      localStorage.setItem("darkMode", JSON.stringify(false));
    }
  }, []);
  const [darkMode, setDarkMode] = useState(false);
  const copyPhoneToClipboard = () => {
    const phone = document.querySelector(".number");
    navigator.clipboard.writeText(phone.innerText);
    alert("Phone copied ");
  };
  const copyAdressToClipboard = () => {
    const email = document.querySelector(".email");
    navigator.clipboard.writeText(email.innerText);
    alert("Email copied ");
  };
  return (
    <div className={darkMode ? "dark  " : ""}>
      {/* hero */}
      <section className=" dark:bg-[#191716]  min-h-screen">
        <div className="px-10 mb-8">
          <Nav darkMode={darkMode} setDarkMode={setDarkMode} />
          <Hero />
          <h1 className=" dark:text-[#e6af2e] font-bold text-5xl py-5">
            Services
          </h1>
          <Services />

          <Projects />
          <h1 className=" dark:text-[#e6af2e] mt-3 font-bold text-5xl py-5">
            Contact
          </h1>
          <p className="dark:text-[#E0E2DB]">click to copy to clipboard :</p>
          <Contact
            copyAdressToClipboard={copyAdressToClipboard}
            copyPhoneToClipboard={copyPhoneToClipboard}
          />
        </div>
        <Footer />
      </section>
    </div>
  );
}

export default App;
